<template>
    <div class="feed-back flex flex-col items-center gap-2">
        <div v-if="$slots.default || title" class="feed-back-message text-grey-90 text-xs">
            <slot>{{ title }}</slot>
        </div>
        <span class="flex items-center gap-1">
            <SvgIcon
                :icon="iconLike"
                :class="status === 'like' ? '!fill-blue-500 hover:!fill-blue-600' : 'hover:!fill-blue-500'"
                class="w-6 h-6 fill-grey-55 cursor-pointer animate transition-colors"
                @click="handleLike"
            />
            <SvgIcon
                :icon="iconLike"
                :class="status === 'dislike' ? '!fill-blue-500 hover:!fill-blue-600' : 'hover:!fill-blue-500'"
                class="w-6 h-6 fill-grey-55 rotate-180 cursor-pointer animate transition-colors"
                @click="handleFeedback"
            />
        </span>
    </div>
</template>

<script setup lang="ts">
import type { FeedbackType } from '@/types/feedback';
import iconLike from '@patsnap-ui/icon/assets/solid/like.svg';
import SvgIcon from '@telecom/shared/components/SvgIcon.vue';
import { useCommands } from '@telecom/shared/composables/use-commands';
import { ref } from 'vue';

const props = defineProps<{
    title?: string;
    /**
     * 反馈的功能点
     */
    type?: FeedbackType
}>();

const { executeCommand } = useCommands();

function getFeedBackOption() {
    return {
        type: props.type,
    };
}

async function handleFeedback() {
    if (status.value === 'dislike') {
        status.value = 'none';
        return;
    }
    if (status.value != 'none') {
        return;
    }
    status.value = 'dislike';
    executeCommand('feedback:open', getFeedBackOption()).catch(() => {
        status.value = 'none';
    });
}

const status = ref<'like' | 'dislike' | 'none'>('none');

function handleLike() {
    if (status.value === 'like') {
        status.value = 'none';
        return;
    }
    if (status.value != 'none') {
        return;
    }
    status.value = 'like';
    executeCommand('feedback:like', getFeedBackOption()).catch(() => {
        status.value = 'none';
    });
}
</script>
